import cx from "classnames";
import React from "react";
import * as styles from "./Spinner.module.css";
const Spinner = ({
  testId = "spinner",
  branded,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.root, { [styles.branded]: branded }, className),
  "data-testid": testId,
  ...rest
});
var Spinner_default = Spinner;
export {
  Spinner,
  Spinner_default as default
};
